import { useGetUserSubscriptions } from 'queryHooks/Profile/Billing/useGetSubscriptions';
import { CurrentSubscriptions } from 'pages/Profile/components/Subscriptions/CurrentSubscriptions/CurrentSubscriptions';
import { BillingHistory } from 'pages/Profile/components/Subscriptions/BillingHistory/BillingHistory';
import { useGetUserInvoices } from 'queryHooks/Profile/Billing/useGetInvoices';

export const SubscriptionsTab = () => {
  const { data: userSubscriptions, isPending: isUserSubscriptionsPending } = useGetUserSubscriptions();
  const { data: userInvoices, isPending: isUserInvoicesPending } = useGetUserInvoices();

  return (
    <>
      {!isUserSubscriptionsPending && !isUserInvoicesPending && (
        <>
          <CurrentSubscriptions
            userSubscriptions={userSubscriptions}
            hasNoActiveSubscriptions={typeof userInvoices === 'string' || !userSubscriptions.length}
          />
          {typeof userInvoices !== 'string' && userInvoices && <BillingHistory billingHistory={userInvoices} />}
        </>
      )}
    </>
  );
};

export default SubscriptionsTab;
